<template>
  <div class="pt72 tac blank">
    <img src="@/assets/images/400.png" />
    <h1>404</h1>
    <p class="py24">抱歉，你访问的页面不存在</p>
    <el-button type="primary" @click="$router.push({ name: 'Home' })">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'Exception',
}
</script>

<style lang="scss">
.blank {
  img {
    width: 384px;
  }
  h1 {
    font-size: 32px;
    color: #1e1f23;
    line-height: 24px;
  }
  p {
    font-size: 14px;
    line-height: 14px;
    color: #999ea8;
  }
}
</style>
